<template>
    <div class="space-y-1">
        <label id="listbox-label" class="block text-sm leading-5 font-medium text-gray-700">
            {{ label }}
        </label>
        <div class="relative">
            <span class="inline-block w-full rounded-md shadow-sm z-40">
                <button @click="open = !open" type="button" aria-haspopup="listbox" aria-expanded="true" aria-labelledby="listbox-label"
                    class="cursor-default relative w-full rounded-md border border-gray-300 bg-white pl-3 pr-10 py-2 text-left
                    focus:outline-none focus:ring-blue focus:border-blue-300 transition ease-in-out
                    duration-150 sm:text-sm sm:leading-5">
                    <div class="flex items-center space-x-3">
                        <div class="flex-shrink-0 h-6 w-6 rounded-full" :class="`bg-${selectedColor}`"></div>
                        <span class="block truncate">
                        {{ selectedColor }}
                        </span>
                    </div>
                    <span class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                        <svg class="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="none" stroke="currentColor">
                            <path d="M7 7l3-3 3 3m0 6l-3 3-3-3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </span>
                </button>
            </span>

            <!-- Select popover, show/hide based on select state. -->
            <div v-if="open" class="absolute mt-1 w-full rounded-md bg-white shadow-lg z-50">
                <ul tabindex="-1" role="listbox"
                    class="max-h-56 rounded-md py-1 text-base leading-6 ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm sm:leading-5">
                    <!--
                      Select option, manage highlight styles based on mouseenter/mouseleave and keyboard navigation.

                      Highlighted: "text-white bg-indigo-600", Not Highlighted: "text-gray-900"
                    -->
                    <li v-for="color in palette" id="listbox-item-0" role="option" @click="select(color)"
                        class="text-gray-900 hover:text-white hover:bg-indigo-600 cursor-default select-none relative py-2 pl-3 pr-9 cursor-pointer">
                        <div class="flex items-center space-x-3">
                            <div class="flex-shrink-0 h-6 w-6 rounded-full" :class="`bg-${color}`"></div>
                            <span class="font-normal block truncate" :class="[selectedColor === color ? 'font-semibold' : 'font-normal']">
                                {{ color }}
                            </span>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "InputSelectColor",
        props: {
            label: String,
            palette: Array,
            selected: String
        },
        data() {
            return {
                open: false,
                selectedColor: this.selected,
            }
        },
        methods: {
            select(color) {
                this.selectedColor = color;
                this.open = false;
                this.$emit('input', color);
            }
        }
    }
</script>
